class VideoModal {
  constructor(el, opt) {
    this.el = el;
    this.options = opt;
    this.init();
  }

  init() {
    this.openEls = document.querySelectorAll(this.options.open);
    this.closeEls = document.querySelectorAll(this.options.close);
    this.iframe = this.el.getElementsByTagName('iframe')[0].contentWindow;
    this.bind();
  }

  bind() {
    // Open Buttons
    if ( this.openEls.length ) {
      for ( let i = 0; i < this.openEls.length; i++ ) {
        this.openEls[i].addEventListener('click', e => this.open(e));
      }
    }

    // Close Buttons
    if ( this.closeEls.length ) {
      for ( let i = 0; i < this.closeEls.length; i++ ) {
        this.closeEls[i].addEventListener('click', e => this.close(e));
      }
    }

    // Close on escape
    document.addEventListener('keyup', e => {
      if ( e.keyCode == 27 ) {
        this.close(e);
      }
    });
  }

  close(e) {
    this.el.classList.remove('is-open');
    if ( this.iframe !== null )
      this.iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }

  open(e) {
    this.el.classList.add('is-open');
    if ( this.iframe !== null )
      this.iframe.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }

}

export default VideoModal;



// WEBPACK FOOTER //
// ./scripts/components/videomodal.js